import { Component, OnInit } from "@angular/core";
import { Parametro, PolizaService } from "src/app/poliza/poliza.service";
import { ReportesService } from "../reportes.service";
import * as XLSX from 'xlsx';

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let renderizarDatePickers: Function;
declare let formatearFecha: Function;
declare let obtenerFecha: Function;
declare let convertirAFecha: Function;
declare let mostrarToast: Function;

@Component({
    selector: 'reporte',
    templateUrl: './reporte.component.html',
    styleUrls: ["./reporte.component.css"]
})
export class ReporteComponent implements OnInit{
    campos: any[] = [];
    ramos: any[] = [];
    ramo: number;
    agencias: any[] = [];
    agencia: number;
    puntosVenta: any[] = [];
    puntoVenta: number;
    fechaDesde: string;
    fechaHasta: string;
    camposReporte: any[] = [];
    reporte: any[] = [];
    encabezados: string[] = [];

    constructor(private reportesService: ReportesService, private polizaService: PolizaService){}

    async ngOnInit(){
        mostrarLoader();
        this.camposReporte = await this.reportesService.consultarCamposReporte();
        this.ramos = await this.polizaService.consultarRamos();
        this.ramos = [{codigo_ramo: 0, nombre: 'TODOS'},  ...this.ramos];
        await this.cargarAgenciasFiltro();
        renderizarDatePickers();
        ocultarLoader();
    }

    async cargarAgenciasFiltro(){
        const cod_suc = sessionStorage.getItem('cod_suc'),
              cod_agt = sessionStorage.getItem('cod_agt'),
              cod_tagt = sessionStorage.getItem('cod_tagt');
        let parametrosAgencias: Parametro[]=[
            {llave: "cod_sucursal", valor: cod_suc ? cod_suc : '0'},
            {llave: "cod_agente", valor: cod_agt ? cod_agt : '0' },
            {llave: "cod_tipo_agente", valor: cod_tagt ? cod_tagt : '0'}            ,
            {llave: "Cod_UsuarioSISE", valor:  sessionStorage.getItem("codusuariosise") ?  sessionStorage.getItem("codusuariosise") : '0'}
        ];

        let result=await (this.polizaService.consultarAgencias(true, parametrosAgencias));

        let agenciasResult = result.map(element => {return {codigo_agencia: element.codigoSucursal, nombre: element.nombreSucursal}});

        this.agencias = [{codigo_agencia: 0, nombre: 'TODOS'},...agenciasResult];
    }

    async cargarPuntosVenta(){
        const codigoUsuarioSISE = sessionStorage.getItem("codusuariosise");
        if(this.agencia){
            this.puntosVenta = await this.polizaService.consultarPuntosVenta(this.agencia, codigoUsuarioSISE) ;
            this.puntosVenta = [{codigo_punto_venta: 0, nombre: 'TODOS'},  ...this.puntosVenta];
        }
    }

    formatearFecha(modelo, propiedad, fecha){
        modelo[propiedad] = formatearFecha(fecha);
    }

    obtenerFecha(modelo, propiedad, id){
        let fecha = obtenerFecha(id);
        modelo[propiedad] = fecha.toLocaleString("es-CO", {});
    }

    async consultarReporte(){
        mostrarLoader();
        const fechaDesde = (this.fechaDesde) ? convertirAFecha(this.fechaDesde) : undefined;
        const fechaHasta = (this.fechaHasta) ? convertirAFecha(this.fechaHasta) : undefined;
        let result: any[] = await this.reportesService.obtenerReporte(
            (this.campos.length > 0) ? this.campos : null,
            fechaDesde,
            fechaHasta,
            (this.ramo) ? this.ramo : 0,
            (this.agencia) ? this.agencia : 0,
            (this.puntoVenta) ? this.puntoVenta : 0
        );
        if(this.campos.length == 0)
            mostrarToast("Seleccione al menos un campo.");
        else if(result.length == 0)
            mostrarToast("La consulta no encontró coincidencias con los filtros especificados.");

        result = this.eliminarDuplicados(result);

        this.reporte = result.map(x => {
            let object = [];
            this.campos.forEach(y =>{
                object.push(x[y.trim()]);
            });
            return object;
        });
        this.encabezados = [];
        this.campos.forEach(x =>
            this.encabezados.push(this.camposReporte.find(y => y.nombre_campo == x).nombre_campo_usu));

        ocultarLoader();
    }

    eliminarDuplicados(arr: any[]): any[] {
      const uniqueRecords = [];
      const uniqueRecordKeys = new Set();

      for (const record of arr) {
          const key = this.campos.map((campo) => record[campo.trim()]).join("-");
          if (!uniqueRecordKeys.has(key)) {
              uniqueRecordKeys.add(key);
              uniqueRecords.push(record);
          }
      }

      return uniqueRecords;
  }

    tableToXLSX() {
      mostrarLoader();
      console.log("ReporteTabla", this.reporte);

      // Formatear las fechas en la matriz de datos
      const formattedData = this.formatProperties(this.reporte);

      // Agregar los encabezados al inicio de la matriz de datos
      formattedData.unshift(this.encabezados);

      for (let i = 0; i < formattedData.length; i++) {
    for (let j = 0; j < formattedData[i].length; j++) {
      if (typeof formattedData[i][j] === 'number') {
        formattedData[i][j] = formattedData[i][j].toString();
      }
    }
  }

      // Crear el libro de Excel
      const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

      // Escribir el archivo
      XLSX.writeFile(workbook, "Reporte_" + (new Date().toLocaleDateString("es-CO")) + ".xlsx");

      ocultarLoader();
    }

    tableToTxt(){
      mostrarLoader();
      console.log("ReporteTabla", this.reporte);

      // Formatear las fechas en la matriz de datos
      const formattedData = this.formatProperties(this.reporte);

      // Agregar los encabezados al inicio de la matriz de datos
      formattedData.unshift(this.encabezados);

      // Crear el libro de Excel
      const worksheet = XLSX.utils.aoa_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte");

      // Escribir el archivo
      XLSX.writeFile(workbook, "Reporte_" + (new Date().toLocaleDateString("es-CO")) + ".txt");

      ocultarLoader();
  }

    formatDate(date: Date): string {
      const day = ('0' + date.getDate()).slice(-2);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const year = date.getFullYear();
      const hours = ('0' + ((date.getHours() + 11) % 12 + 1)).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      const amPM = date.getHours() >= 12 ? 'P. M.' : 'A. M.';

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${amPM}`;
    }

    formatProperties(data: any[][]): any[][] {
      const newData = data.map((row) => {
        return row.map((value) => {
          if (value instanceof Date) {
            return this.formatDate(value);
          }
          return value;
        });
      });

      return newData;
    }
}
